import { render, staticRenderFns } from "./SubmitAssessment.vue?vue&type=template&id=2694c3b8&scoped=true"
import script from "./SubmitAssessment.vue?vue&type=script&lang=js"
export * from "./SubmitAssessment.vue?vue&type=script&lang=js"
import style0 from "./SubmitAssessment.vue?vue&type=style&index=0&id=2694c3b8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694c3b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2694c3b8')) {
      api.createRecord('2694c3b8', component.options)
    } else {
      api.reload('2694c3b8', component.options)
    }
    module.hot.accept("./SubmitAssessment.vue?vue&type=template&id=2694c3b8&scoped=true", function () {
      api.rerender('2694c3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/StudentAnswer/components/SubmitAssessment.vue"
export default component.exports